import { Link } from "gatsby"
import React from "react"
import styled from "@emotion/styled"
import { css } from "@emotion/react"
import { FaCalendarCheck, FaPhone } from "react-icons/fa"
import { MdPinDrop } from "react-icons/md"

export default () => (
  <Wrapper>
    <H2>
      Practical <span>information</span>
    </H2>
    <hr />
    <Row>
      <Col1>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d21002.235330161733!2d2.302042746736518!3d48.85288200559685!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xf1a966571b85f101!2sEspace+M%C3%A9dical+Vauban!5e0!3m2!1sfr!2sus!4v1559670912011!5m2!1sfr!2sus"
          width="100%"
          height="370"
          frameborder="0"
          allowfullscreen
          title="Access map to Espace Medical Vauban in Paris 7"
        />
      </Col1>
      <Col2>
        <p>
          The consultations take place at{" "}
          <Link to="/en/consultation/">Vauban Medical Center</Link> (2A, Avenue
          de Ségur, 75007 Paris) on Tuesday and Friday, and at{" "}
          <Link to="/en/clinic/">Clinique du Sport</Link> (36, Boulevard Saint
          Marcel, 75005 Paris) on Mondays and Fridays.
        </p>

        <p
          css={css`
            margin-top: 15px;
          `}
        >
          <strong>How to make an appointment?</strong>
        </p>

        <P>
          <a href="tel:+33153598809">
            <FaPhone /> Espace Médical Vauban<span> (Virginie)</span> : (+33) 1
            53 59 88 09 09
          </a>
        </P>
        <P>
          <a href="tel:+33186867505">
            <FaPhone /> Clinique du Sport <span>(Paula) </span>: (+33) 1 86 86
            75 05 09
          </a>
        </P>
        <P>
          <a
            href="https://www.doctolib.fr/chirurgien-orthopediste/paris/philippe-roure"
            targer="_blank"
            rel="noreferrer noopener"
          >
            <FaCalendarCheck /> Make an appointment Doctolib (on site or online)
          </a>
        </P>

        <p
          css={css`
            line-height: 1.5em;
            font-style: italic;
            margin-top: 15px;
            @media (max-width: 678px) {
              font-size: 0.93em;
              text-align: center;
            }
          `}
        >
          Only part of the agenda is accessible on Doctolib, call us to know all
          the appointments available.
        </p>
        <Button to="/en/contact/">
          <MdPinDrop
            css={css`
              transform: translateY(2px);
            `}
          />{" "}
          Contact & Access
        </Button>
      </Col2>
    </Row>
  </Wrapper>
)

const Wrapper = styled.section`
  background-color: white;
  border-radius: 5px;
  margin: 2.5em auto 0.5em;
  padding: 1.5em 1.5em 1em 1.5em;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 7px;
  @media (max-width: 678px) {
    padding: 1em;
  }
`
const H2 = styled.h2`
  text-align: center;
  padding-top: 0.25em 0 0.5em;
  font-weight: 400;
  font-size: 2.4em;
  margin-block-start: 0;
  span {
    font-weight: 800;
  }
  @media (max-width: 678px) {
    font-size: 2.15em;
  }
`

const Row = styled.div`
  display: flex;
  margin-top: 40px;
  @media (max-width: 678px) {
    display: block;
  }
`

const Col1 = styled.div`
  flex: 50%;
  padding-right: 15px;
  @media (max-width: 678px) {
    padding: 0;
    margin-bottom: 5px;
  }
`

const Col2 = styled.div`
  flex: 50%;
  padding-left: 15px;
  @media (max-width: 678px) {
    padding: 0;
  }
`

const P = styled.p`
  margin-bottom: 3px;
  a {
    border-bottom: none;
  }
  @media (max-width: 678px) {
    font-size: 0.93em;
    span {
      display: none;
    }
  }
`

const Button = styled(Link)`
  display: block;
  margin: 0 auto;
  width: 170px;
  text-align: center;
  text-decoration: none;
  margin-top: 15px;
  padding: 0.4em 0.8em 0.5em;
  background-color: #d69c31;
  cursor: pointer;
  color: white;
  font-weight: 600;
  font-size: 0.94em;
  letter-spacing: 0.035em;
  border-radius: 4px;
  transition: all 0.15s ease-in-out;
  :hover,
  :focus {
    color: white;
    background-color: rgba(44, 44, 44, 0.96);
    outline: none;
    transition: all 0.15s ease-in-out;
  }
`
